import React from "react";
import BootstrapCarousel from "../components/ui/carousel/bootstrapCarousel";

const Main = () => {
    return <BootstrapCarousel />;
};

export default Main;
